'use strict';

import {ItemEditCtrl} from "./itemeditctrl.js";
import {itemModel} from "../models/itemmodel.js";

export class ItemCreateCtrl extends ItemEditCtrl
{
	

}
